/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { ONBOARDING_DATA_ATTR } from '../onboardingConstants';
import { EOnboardingComponentsId } from '../types/onboardingTypes';

const formatOnboardingSelector = (id: EOnboardingComponentsId) => `[${ONBOARDING_DATA_ATTR}=${id}]`;

export default formatOnboardingSelector;
